import { useEffect, useState } from 'react';
import { Timeline, TimelineItem }  from 'vertical-timeline-component-for-react';
import moment from 'moment';
import { Card } from '../../components/Card';
import { ModalBody, ModalHeader, ModalPanel } from '../../components/Modal';
import { MdSearch } from 'react-icons/md';
import { Input, SelectInput } from '../../components/Form';
import './styles.scss';

const HistoricCard = ({ dataType = 'atendimento', id, name, email, handleClick }) => {
  return <div className="historic__card__container" onClick={handleClick}>
    <div className="historic__type">{dataType}</div>
    <div className="historic__content">
      <text>Hash: <span>{id}</span></text>
      <text>E-mail: <span>{email}</span></text>
      <text>Nome: <span>{name}</span></text>
    </div>
  </div>
}

const HistoricDetails = ({ data, user }) => {
  const [formattedData, setFormattedData] = useState([])

  useEffect(() => {
    if(data && user) {
      let questions = [];

      data.map(item => {
        const newQuestions = item.users
        .filter( userData => userData?.userEmail === user?.email)
        .map(({value, questionTitle, isPublic}) => ({ value, title: questionTitle, isPublic }))

        questions = [...questions, ...newQuestions];
      })

      setFormattedData({ ...user, questions });
    }
  }, [data, user])

  return <div className='historic__details__container'>
    <div className="details__body">
      {formattedData && formattedData.questions && formattedData.questions.map( question => (
        <div className="details__content">
          <h5>{question?.title}</h5>
          <p className="content_answer">
            <span className={`${!question?.isPublic ? 'public' : 'private'}`}>{`Resposta ${!question?.isPublic ? 'pública' : 'privada'}`}</span>
            <span>{question?.value.replaceAll('|', ', ')}</span>
          </p>
        </div>
      ))}
    </div>
  </div>
}

const DateCard = ({ date }) => <div className="date__container">{date}</div>

export const HistoricScreen = ({ data, modalIsOpen, toggleModalIsOpen, selectedUser }) => {
  return <Card>
      <div className="historic__header">
        <div className="input-select">
            <Input
              placeholder={"Pesquise pelo email, nome ou HASH"}
              // onChange={(e) => setFilter({ ...filter, search: e.target.value })}
              hasIcon={<MdSearch size={16} />}
              // isWhite
              hasFocus={false}
            />
            <SelectInput
              isClearable={true}
              placeholder="Selecione o Tipo"
              value={'Atendimento'}
              // options={tagsOptions && tagsOptions.map(({ id, name }) => ({
              //   value: id,
              //   label: name,
              // }))}
              // whiteVariation
              // onChange={(tag) => setFilter((filter) => ({ ...filter, tag }))}
            />
        </div>
      </div>
      <Timeline lineColor={'#e1e5e3'} className="timeline__container">
        {data && data.map((item, index) => (
          <TimelineItem
            key={index}
            dateComponent={<DateCard date={moment(item?.date, 'YYYY-MM-DD').format('DD/MM/YYYY') } />}
            style={{ color: '#0146ad' }}
          >
            {
              item.users && [...new Set(item.users.map( user => user.userId))]
              .map((user, idx) => {
                const { userId, userEmail, userName} = item.users.filter(({userId}) => user === userId)[0];
                return <HistoricCard
                  key={`historicUser-${idx}`}
                  dataType="Atendimento"
                  id={userId}
                  email={userEmail}
                  name={userName}
                  handleClick={() => toggleModalIsOpen({email: userEmail, name: userName, hash: userId, date: item?.date})}
                /> 
              })
            }
          </TimelineItem>
        ))}
      </Timeline>
      <ModalPanel modalIsOpen={modalIsOpen} closeModal={toggleModalIsOpen}>
        <ModalHeader closeModal={toggleModalIsOpen} title="Detalhes do usuário" />
        <ModalBody style={{minWidth: "1000px", minHeight: "700px", padding: "24px"}} >
          <HistoricDetails
            data={data.filter( item => item?.date === selectedUser?.date)}
            user={selectedUser}
          />
        </ModalBody>
      </ModalPanel>
  </Card>
}